module.exports = __webpack_public_path__ + "img/headBar.cef91b78.png";